import { render, staticRenderFns } from "./WysiwygToolbar.vue?vue&type=template&id=5cd8ca3e&lang=pug&"
import script from "./WysiwygToolbar.vue?vue&type=script&lang=js&"
export * from "./WysiwygToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports